/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: partner-due-date-templates-editor-component.ts
 *
 * Created by randysorensen on 6/1/18.
 */

function PartnerDueDateTemplatesEditorController(
    this: JS5Object,
    _: JS5Object,
    $q: JS5Object,
    $route: JS5Object,
    $timeout: JS5Function,
    BreadcrumbService: JS5Object,
    PartnerEditService: JS5Object,
    PermissionsService: JS5Object,
    SidebarService: JS5Object,
    UtilsService: JS5Object
) {

    const setBreadcrumbData = () => {
        this.partnerBreadcrumb.location = `/system/partners/edit/${this.partnerObject.id}/dueDateTemplates`;
        this.partnerBreadcrumb.name = this.partnerObject.name;
        this.breadcrumbName = _.get(this, 'dueDateTemplateObject.name', 'New SLA Template');
    };

    const getEditData = () => {
        if (this.canRead) {
            this.loadingIndicator.show = true;
            PartnerEditService.getDueDateTemplatesEditViewData().then((editData: JS5Object) => {
                this.partnerObject = editData.partnerObject;
                this.availableEmailTemplates = editData.availableEmailTemplates;
                this.availableBusinesses = editData.availableBusinesses;
                this.dueDateTemplateObject = editData.dueDateTemplateObject;

                if (_.isNil(this.dueDateTemplateObject.id)) {
                    this.editorForm.$setDirty();
                }

                setBreadcrumbData();
            }).finally(() => {
                $timeout(() => {
                    this.loadingIndicator.show = false;
                });
            });
        }
    };

    const getPermissions = () => {
        const partnerDueDateTemplatesViewState = 'SYSTEM_PARTNERS_DUE_DATE_TEMPLATES_VIEW_STATE';

        return $q.all({
            canRead: PermissionsService.canRead(partnerDueDateTemplatesViewState),
            canWrite: PermissionsService.canWrite(partnerDueDateTemplatesViewState)
        }).then((permissions: JS5Object) => {
            this.canRead = permissions.canRead;
            this.canWrite = permissions.canWrite;
        });
    };

    this.onStepperChanged = function (object: JS5Object, prop: string, min: number, max: number) {
        UtilsService.clampNumericProp(object, prop, min, max);
    };

    const requiredFieldsArePopulated = () => {
        let requiredFields = [
            'name',
            'expression',
            'overdueTemplate',
            'dueDateWarningTemplate',
            'warningThresholdHours'
        ];

        let allFieldsPopulated = requiredFields.reduce((accum, field) => {
            return accum && UtilsService.hasData(this.dueDateTemplateObject[field]);
        }, true);

        return allFieldsPopulated;
    };

    const initToolbar = () => {
        this.toolbarButtonDefs = [
            {
                label: 'Save',
                enabled: (): boolean => this.editorForm.$dirty && this.canWrite && requiredFieldsArePopulated(),
                onClick: (): void => {
                    this.loadingIndicator.show = true;
                    PartnerEditService.saveDueDateTemplate(this.dueDateTemplateObject).then((newDueDateTemplateObject: JS5Object) => {
                        this.dueDateTemplateObject = newDueDateTemplateObject;
                        $route.updateParams({dueDateTemplateId: this.dueDateTemplateObject.id});
                        setBreadcrumbData();
                    }).finally(() => {
                        this.loadingIndicator.show = false;
                    });
                }
            },
            {
                label: 'Revert',
                enabled: (): boolean => this.editorForm.$dirty,
                onClick: (): void => {
                    PartnerEditService.revertDueDateTemplate(this.partnerBreadcrumb.location);
                    this.dueDateTemplateObject = PartnerEditService.dueDateTemplateObject;
                    setBreadcrumbData();
                }
            },
            {
                label: 'Close',
                enabled: (): boolean => true,
                onClick: (): void => PartnerEditService.exitEdit(this.partnerBreadcrumb.location)
            }
        ];
    };

    this.$onInit = () => {
        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };

        this.canRead = false;
        this.canWrite = false;

        this.breadcrumbName = '';

        this.partnerBreadcrumb = {
            location: '',
            name: '...',
            params: null,
        };

        initToolbar();

        SidebarService.editService = PartnerEditService;
        BreadcrumbService.editService = PartnerEditService;

        if (BreadcrumbService.getBreadcrumbs().length < 2) {
            // add partner breadcrumb if it's not already added
            BreadcrumbService.addBreadcrumb(this.partnerBreadcrumb);
        }

        getPermissions().then(getEditData);
    };

    this.$postLink = () => {
        $timeout(() => {
            PartnerEditService.editorForm = this.editorForm;
        });
    };

}

angular
    .module('prism-ui.partner')
    .component('partnerDueDateTemplatesEditor', {
        templateUrl: 'system/partner/editor/components/view/dueDateTemplates/editor/partner-due-date-templates-editor-template.html',
        controller: PartnerDueDateTemplatesEditorController,
        bindings: {}
    });
